import 'dayjs/locale/es'

import { i18n, type Messages } from '@lingui/core'
import dayjs from 'dayjs'
import { messages as enMessages } from 'locales/en/messages.po'
import { messages as esMessages } from 'locales/es/messages.po'
import { type GeckoLanguage, localeForLanguage } from 'utils/localeLanguage'

const catalogs: Record<GeckoLanguage, Messages> = {
  en: enMessages,
  es: esMessages,
}

/** Switches the Lingui catalog and the dayjs locale to the given language. */
export const activateLanguage = (language: GeckoLanguage): void => {
  i18n.load(language, catalogs[language])
  i18n.activate(language, localeForLanguage(language))
  dayjs.locale(language)
}
